import { Amplify } from "aws-amplify";
import { AppSettings, loadAppSettings } from "./AppSettings";

export const AUTOMATION_AUTHORIZER_REDIRECT_SIGN_IN =
  location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "") + "/loginRedirect.html";

function getAmplifyConfig() {
  return {
    identityPoolId: AppSettings().authConfig.identityPoolId,
    userPoolId: AppSettings().authConfig.userPoolId,
    userPoolWebClientId: AppSettings().authConfig.userPoolWebClientId,
    region: AppSettings().region,
    mandatorySignIn: false,
    oauth: {
      domain: new URL(AppSettings().authConfig.userPoolDomainUrl).host,
      scope: ["email", "openid"],
      responseType: "code",
      clientId: AppSettings().authConfig.userPoolWebClientId,
      redirectSignIn: AUTOMATION_AUTHORIZER_REDIRECT_SIGN_IN,
    },
  };
}

export async function configureAmplify() {
  await loadAppSettings();
  Amplify.configure(getAmplifyConfig());
}
